export const environment = {
  production: true,

  version: '6.6.1-HOMOLOG',

  url:'https://back.cope-agenda.hie.tec.br/marcacao-business/api/v1/',

  appTitle: 'CopeAgenda',

  appAlias: 'COPE_AGENDA',

  includeUnidades: true,

  includeMarcacaoConsultas: true,

  exibirPropaganda: true,

  // CSS
  headerPath: 'assets/images/header_cope_agenda.png',

  containerIndex: 'container-index-cope-agenda',

  customNavBar: 'custom-nav-bar-cope-agenda',

  cardLogin: 'card-login-cope-agenda',
};
